module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER TWO")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_vm._v("“G"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("INA")]), _vm._v("!")]), _vm._v(" You’re wanted out front!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was more a command than a call. Gina Terlizzi quickly set aside the greenery she was sorting for the floral arrangements and hurried from the back room to answer it, wondering why her presence was required "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("out front.")]), _vm._v(" As the owner of the florist shop, her aunt preferred to deal with the customers herself.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The reason was instantly evident and punched her heart with shock—Marco, her two-and-a-half-year-old son, firmly in the grip of an elderly woman. And not just any elderly woman. Recognition of Isabella Valeri King came hard and fast, doubling the shock.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("This shop was in Cairns and King’s Castle was in Port Douglas, seventy kilometres further north, but the whole Italian community in far North Queensland knew this remarkable woman and held her in the highest respect. A quiver of apprehension ran down Gina’s spine at being put on the mat in front of her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Are you the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("madre")]), _vm._v(" of this boy?” she demanded, her aristocratic bearing taut with disapproval.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gina tore her gaze from the piercing dark eyes to look down at her son who was gazing up at his captor with something like awe. “Yes,” she answered huskily. “What have you done, Marco? Why aren’t you in the backyard?”")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He gave her his triumphant achievement look, his brown eyes dancing with mischief, an appealing smile flashing from his adorable little face, his mop of dark curls bobbing as he proudly confessed, “I got boxes an’ climbed up an’ opened the gate.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Which meant he wasn’t safely contained here at work anymore. Gina heaved a deeply exasperated sigh. “Then what?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I rode my bike.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He was out on the street, pedalling his tricycle at wild speed, and almost ran into me,” came the telling accusation.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gina stood very straight, facing the music as best she could. “I’m terribly sorry that his lack of control put you at risk, Mrs. King, and I’m grateful you’ve brought him in to me. I thought he was playing safely in the backyard.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It seems your son is an enterprising child. Boys will be boys. You must always keep their very active ingenuity in mind.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("This softer piece of advice reduced Gina’s tension considerably. “I will. Thank you again for returning him to me, Mrs. King.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("She was subjected to more scrutiny, as though everything about her was being meticulously catalogued; her long streaky-brown hair, the bangs that swept across her forehead, her thickly lashed amber eyes, her too wide mouth, the bone structure of her face, her long neck, the obvious curves of her full breasts underneath her sleeveless blouse, the neatness of her waist, emphasised by the belt on her skirt, the breadth of her hips, the ")]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("shape of her bare legs and her feet, which were simply encased in sandals.")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was embarrassing, as though she was being measured for being a careless creature who didn’t have enough interest in looking after her son properly. Which wasn’t true at all. Gina prided herself on being a good mother. It was just that Marco could be a little devil at times.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I understand you are a widow.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The knowing statement surprised her into replying, “Yes, I am.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How long?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Two years.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Perhaps the boy needs a man’s hand.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gina flushed at the implied criticism. “Marco does have uncles.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You are a very attractive young woman. No one is courting you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No. I…uh…haven’t met anyone I…um,…” She floundered hopelessly under the direct beam of those intensely probing eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You were very attached to your husband?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, yes…”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“This is not good for the boy—your working in a shop, unable to supervise him properly. You need a husband to support you. The right man would lift this burden from you.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("“Yes,” she agreed. What else could she do? Arguing with Isabella Valeri King was far too daunting an option. She could only hope her aunt, who was standing silently by, would not take offence. It was a family fa")]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("vour that she had a part-time job here, and allowed to bring Marco with her.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("As long as he didn’t make a nuisance of himself!")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She would definitely be in trouble once Isabella Valeri King departed. However, no immediate exit took place. Despite having delivered her lecture on Gina’s situation, the old lady stood her ground and suddenly took an entirely different tack.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You are also a wedding singer.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes.” How did she know these things about her?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Your agent sent me a tape of your songs. You have a lovely voice.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Finally enlightenment. “Thank you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You are aware that weddings are held at King’s Castle?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, of course.” The most exclusive and expensive weddings!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I am always looking for good singers and I have found it wise to test a voice in the ballroom. The acoustics are different to those in a recording studio.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The fabled ballroom! Gina had never been there but stories about the castle abounded. Was this a chance to be actually hired as a singer for fabulous weddings? Could she ask for a much bigger fee? Travelling money? It was an hour’s drive from Cairns to Port Douglas. Her mind zipped through a whole range of exciting possibilities.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I would require a trial run. Are you free to come on Sunday afternoon?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("“Yes.” It wouldn’t have mattered if she’d asked for the moon, Gina would have said yes. This was a huge ")]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("opportunity for her to earn far more than the peanuts she was usually paid for singing.")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Good. Three o’clock. And bring the boy with you.” She looked down at Marco whose hand she still held firmly. Amazingly he hadn’t tried to wriggle his fingers free of captivity. In fact, he appeared fascinated by this lady who spoke with such authority to his mother. “You will come to visit me with your "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("madre,")]), _vm._v(" Marco.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I could have him minded,” Gina quickly suggested, anxious not to have her audition disturbed by any mischievous behaviour from her unpredictable son.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That earned a stern glare. “You will not.” As though realising her tone was too sharp, she smiled, firstly down at Marco, then at Gina. “He is quite an endearing little boy. I shall enjoy watching him at play. We will have afternoon tea in the loggia and let him run free in the grounds.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s…very kind. Thank you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Go to your "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("madre")]), _vm._v(" now, Marco.” She released his hand and lightly patted his curls. “And do not ride your bike in the street again. It is not the place to play.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He obediently trotted over to Gina’s side and took her hand.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How old is he?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Two and a half.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He rides very well for his age,” came the astonishingly approving comment. “The tricycle is by the door.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thank you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Three o’clock Sunday,” she repeated imperiously.")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We’ll be there, Mrs. King. And thank you once again.”")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Ten minutes to three…Gina slotted her little Honda Swift under one of the bougainvillea and vine-laden pergolas that flanked the steps up to King’s Castle. This was the visitors’ parking area, and apart from her own car it was empty, which made her feel all the more nervous.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For the umpteenth time she checked that the backing tape for her songs was in her handbag. It might not be needed. She had no idea if she was expected to sing with or without music for this audition. At least she had it if it could be used. The driving mirror reflected that her make-up was still fine, not that she wore much—a touch of eyeliner, mascara, lipstick. Her hair was freshly washed and blow-dried to curve around her shoulders. She hoped she looked like a professional singer.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Marco had fallen asleep in his car seat. She’d dressed him in navy shorts and a T-shirt striped in red, green and navy—navy sandals on his feet. With his dark curls and eyes, such strong colours really suited him and he looked very cute. For herself, she’d chosen a sleeveless lemon shift with a navy band edging the armholes and scooped neckline. Teamed with navy accessories, it was an outfit that always made Gina feel smartly dressed—a much-needed boost for confidence today.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("Having unbuckled Marco’s safety harness, she gently woke him then lifted him out. Luckily he was never grumpy after a nap. It was like, “Hi, world! What’s ")]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("new?” and he was all bright-eyed, ready to go and discover it.")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Are we at the castle, Mama?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes. I’ll just lock the car and we’ll walk up to it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I can’t see it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You will in a minute.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As they walked up the steps his gaze was trained in entranced wonder at the tessellated tower that dominated the hill. It was said that Frederico Stefano Valeri, Isabella’s father, had built it so his wife could watch the boats coming in from the sea and the cane fields burning during the harvesting.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Can we go up there, Mama?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not today, Marco. But we will see the ballroom. It has huge balls covered with tiny mirrors hanging from the ceiling, and a wooden floor where the boards have been cut into fancy patterns.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The steps were flanked by rows of magnificent palm trees and terraces with lushly displayed tropical flowers and plants and ferns. At the top of the rise, they moved onto a wide flagstoned path with beautifully manicured lawns of buffalo grass on either side. Ahead of them was a colonnaded loggia which prefaced the entrance to the castle. It covered a very spacious area. In the centre of it was a fountain, around which were casual groupings of chairs and tables. At one of these sat three people and Gina’s feet almost faltered at the charge of nervous excitement that ran through her as recognition sank in.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Alex King")]), _vm._v(" sitting with his grandmother. Alex King and his fiancée, she quickly amended, identifying the ")]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("woman she’d seen in the photograph accompanying the newspaper article on their engagement. He’s taken, she ruefully reminded herself. Besides which, there never had been a chance of her meeting Alex King on any kind of social level—until this very moment. But if ever there was a man to turn her head and make her heart go pitter-pat, he was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("it")]), _vm._v("—The Sugar King.")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Of course she had loved Angelo, her husband. Angelo had been real life. This man had always been—and still was—unattainable fantasy. Yet with his gaze directly on her now as she and Marco approached, Gina could feel her pulse racing and little quivers attacking her thighs. He was so handsome. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Manly")]), _vm._v(" handsome. Big and strong and with that intrinsic air of indomitable authority that seemed to say he could handle anything he was faced with. Definitely a king, measured against other men.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He smiled at Marco who had broken into an excited little skip at Gina’s side. The smile transformed the hard angles of his face, emitting a warm charm. His eyes twinkled at her son—startling blue eyes, given his suntanned olive skin and the thick wavy black hair that declared his Italian heritage. The blue eyes had to have come from his paternal line. Somehow they gave him an even more charismatic presence.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("Probably Gina should have headed for the end of the table where Isabella sat. She didn’t think. She was automatically drawn to the end Alex King occupied. He pushed his chair back and stood up to greet her, making her overwhelmingly aware of just how big and tall he ")]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("was. Such a powerfully built man, and her head was barely level with his broad shoulders.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Belatedly, Gina shot her gaze to his grandmother, whose autocratic command had brought her here and who should be given her prime attention. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I’ve come on business,")]), _vm._v(" Gina fiercely told herself. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Business, business, business…")]), _vm._v(" But it didn’t stop her from being overwhelmingly aware of the magnetic maleness of Alex King.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“My grandson, Alessandro,” the old lady announced with a benign smile that relieved Gina of any fear that she would be judged as ill-mannered.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She flicked an acknowledging glance up at the heart-stopping blue eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“His fiancée, Michelle Banks,” the introductions continued.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gina nodded and smiled and received a perfunctory little curve of the lips in return from the woman seated on the other side of the table. Full pouty lips, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sexy")]), _vm._v(" lips. It was somewhat demoralising to see just how beautiful Michelle Banks was in the flesh—her golden hair sleeked back to a knot at the back, her face so perfectly sculptured it needed no softening effect, big almond-shaped, grey-green eyes, a classic nose, and a swan like neck emphasising her long, model-thin elegance.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She wore one of her signature tie-dyed scarf tops with a halter neckline—a garment that could only be worn well by very slim and small-breasted women—and the artistic pattern of earth colours was complemented by gold hipster slacks which affirmed there was no excess flesh anywhere on the fashion designer’s body.")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gina instantly felt fat. Which was stupid because she really wasn’t. She was simply built on a different scale to Michelle Banks. However, that common sense argument did nothing to lift the lead that had descended on her heart. This was the kind of woman Alex King wanted to marry. Would marry.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Gina Terlizzi and her son, Marco,” Isabella finished.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A pleasure to meet you, Gina. And Marco,” came the warm welcome from her grandson, the deep timbre of his voice striking pleasure chords right through Gina’s body. “A good family, the Terlizzis. Still in fishing boats?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Most of the men are,” she answered, amazed that he knew of them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Many years ago his father, Robert King, had financed the Terlizzi family venture into fishing. His great-grandfather, Frederico Stefano Valeri, had begun the tradition of financing Italian immigrants into businesses when the banks had denied them loans. Everyone knew that the Kings would listen to a deal when more conventional financial institutions would not. Judgement was made more on the capability to succeed than on up-front money, and as far as Gina knew, no one had ever failed to pay back the Kings’ faith in them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And you’re Angelo’s widow,” Alex King went on, his tone softening with sympathy.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She nodded, even more astonished he knew her husband’s name.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I remember reading about him going to the rescue of a lone sailor whose yacht had broken up on the reef.”")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The storm beat him. They both drowned,” she choked out.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A brave man. And a very sad loss to you and your son.” The caring in his eyes squeezed her heart. “I trust your family has looked after you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Very well.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Good! My grandmother tells me you’ve come to sing for her. You must want a drink first. Please…” He gestured to the empty chairs on the near side of the table, opposite to where his fiancée sat. “What would you like…wine, fruit juice, iced water?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Water for me, thank you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And you, Marco?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Juice, please.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Only half a glass for him,” Gina quickly warned as she settled them both on chairs. Her eyes appealed for understanding. “He tends to spill from a full one.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Another warming smile. “No problem.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So…you’re a professional singer,” Michelle Banks drawled, focusing Gina’s attention on her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I do get quite a few engagements—weddings, birthdays, other functions—but I can’t say I make a living from it,” Gina answered truthfully. No point in pretending to be something she wasn’t. In fact, more often than not she was asked to sing by family or friends with no fee offered at all.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I presume you have had some training,” the woman pressed in a slightly critical tone that niggled Gina. What business was it of hers?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If you mean singing lessons, yes. And I’ve competed in many eisteddfods over the years.”")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Then why didn’t you pursue a career with it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not every woman puts a career first,” Isabella dryly interposed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Michelle shrugged. “Seems a waste if your voice is good enough.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She raised her perfectly arched eyebrows at Gina who bristled at the implied put-down. Why did Alex King’s fiancée feel the need to put her on the spot like this. She was a woman who appeared to have everything other women might envy, including the man whose ring she was wearing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It wasn’t the kind of life I wanted,” she answered simply. “As to whether my voice is good enough, I’m here—” she transferred her gaze to Isabella “—for Mrs. King to judge if it meets her requirements.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And I’m looking forward to hearing it,” the older woman said, smiling encouragement. “Indeed, if it is true to your performance on tape…” She looked directly at her grandson. “…you may very well want Gina to sing at your wedding, Alessandro.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Silence. Stillness. For the first time Gina lost her own self-consciousness enough to realise there were tensions at this table that had nothing to do with her. Or perhaps she had become an unwitting focus for them. Very quietly she picked up her glass of water and drank, grateful to be out of the direct firing line.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Michelle Banks glared at Alex, clearly demanding his support. He stirred himself, addressing his grandmother with an air of pained patience.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Nonna, we have already discussed this. Michelle wants a harpist, not a singer.”")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I heard what Michelle wants, Alessandro,” came the coolly dignified reply. “Did I hear what you want?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It is the bride’s day,” he countered with a slight grimace at the contentiousness behind the question.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Isabella regarded his fiancée with an expression of arch curiosity that Gina instantly felt had knives behind it. “Is that what you think, Michelle—that a wedding belongs only to the bride, and the groom must fall in with everything she wishes?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Michelle gave a smug little smile. “Alex is happy for me to have a harp playing.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ve never thought a harp—indeed, any musical instrument—can project the warmth and emotion that a human voice can.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s purely a question of taste,” Michelle argued. “A harp is very elegant.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Undoubtedly. However, to my mind, even within a showcase of elegance, room could be made for some spotlight on love at your wedding.” She turned a smile on Gina. “Are you now refreshed enough to sing?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes. Thank you.” She set her glass down and picked up her handbag. “I did bring a backing tape. Are there facilities for it to be played in the ballroom or…”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Of course.” She nodded to her grandson. “Alessandro will set it up for you and give you a remote control for pausing between songs.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gina’s heart fluttered. Was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("he")]), _vm._v(" going to listen, too? She glimpsed a V of annoyance forming between Michelle Banks’ brows, but said a quick, “Thank you,” to Alex King anyway.")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“My pleasure,” he said kindly, though she couldn’t help wondering if he also was annoyed at this manipulation by his grandmother. It didn’t make for a comfortable audience. His fiancée, for one, was bound to be judging very critically.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Isabella stood up—a definitive signal for them all to rise from the table. Gina hastily removed the glass from Marco’s hands and set him on his feet.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Are we going to see the balls of mirrors now, Mama?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, we are.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Come, Marco. Give me your hand,” Isabella commanded. “I will show you everything while your "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("madre")]), _vm._v(" is preparing to sing for us.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He responded without so much as a hesitation, trotting straight over to her and eagerly taking the offered hand, his eyes sparkling with happy anticipation. What was it that made him so pliable to this old woman when he could be quite obstreperous with other virtual strangers? Gina doubted he would have taken Michelle Banks’ hand so readily. But Isabella King…was he instinctively drawn to the power that emanated from her…the power imbued by so many years of being the matriarch of this family?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was definitely there.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Even Michelle Banks was not about to buck it at this point, although Gina could feel the younger woman’s hostility as they moved as a group to the ballroom. It made Gina wonder if Isabella King was using her as a pawn in a battle she was subtly fighting against her future grand-daughter-in-law.")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She hoped it wasn’t so.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She needed this opportunity to be a straight deal between them, one she could count on to lead to a better situation for her and Marco if her singing was approved. It was a big "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("if,")]), _vm._v(" given the current tensions that were affecting her. Somehow she had to set them aside, concentrate on her singing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Apart from everything else, she would hate to fail in front of Alex King, hate to have him feel pity for her, hate to give his fiancée reason to sneer at her performance.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She had to sing well.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Had to.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Or she would die a million humiliating deaths.")])])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page25"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a33224e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781426886447_ch02.vue
// module id = 72
// module chunks = 0